import React, { useState, useEffect } from "react";
import "./pricing.m.css";
import Icon from "@mdi/react";
import { mdiArrowRight } from "@mdi/js";
import { PRICING_DETAILS, PATH } from "../../../../constants";
import { BQLink } from "../../../atoms/bqlink";
import { loadMoreInteraction } from '../../../../helpers/datalayer-utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

const Pricing = () => {
  const [isLoading, setLoading] = useState(true);
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <div styleName="pricing-card" className="container">
      <div styleName="newsletter-container">
        <div styleName="newsletter-wrap">
          <img src="/icons/message_icon.svg" styleName="message-icon" />
          <img src="/images/story_top_img.svg" styleName="top-banner left" />
          <img src="/images/story_top_img.svg" styleName="top-banner right" />
          <div styleName="heading">Curated Newsletters</div>
          <div styleName="desc">Strategic Insights from Top Editors</div>
          <div onClick={() => loadMoreInteraction('View All Newsletters', userData, pageType, 'Curated Newsletters')}>
            <BQLink
              href={PATH.MYBQ_PAGE + PATH.MYBQ_NEWSLETTER}
              styleName="newsletter-btn"
            >
              View All Newsletters
            </BQLink>
          </div>
          <img
            src="/images/subscription_newsletter.png"
            styleName="newsletter-img"
          />
        </div>
      </div>
      {!isLoading && (
        <div styleName="pricing-section" id="bulk-deals">
          {PRICING_DETAILS.slice(0, 2).map((list, index) => (
            <BQLink href={list.link} styleName="price-card" key={index}>
              <div>
                <img src={list.imgURL} alt="graduate" styleName="student-img" />
              </div>

              <div styleName="text-card">
                <div>
                  <div styleName="price-head">{list.title}</div>
                  <div
                    styleName="desc"
                    className="desktop-only"
                    dangerouslySetInnerHTML={{ __html: list.desc }}
                  ></div>
                  <div
                    styleName="desc"
                    className="mobile-only"
                    dangerouslySetInnerHTML={{ __html: list.desc_mb || list.desc }}
                  ></div>
                  <BQLink styleName="price-btn" href="mailto:profitsupport@ndtv.com" target="_blank">
                    {list.btnText} &nbsp;
                    <Icon path={mdiArrowRight} size="20px" color="#725E42" />
                  </BQLink>
                </div>
              </div>
            </BQLink>
          ))}
        </div>
      )}
    </div>
  );
};

export default Pricing;
